export const processCodeMessage =(key:number)=>{
    switch(key){
        case 0 : return "پردازش نشده";
        case 1 : return "پردازش شده"
        case 2 : return "در حال پردازش"
        case 3 : return "خطا"
    }
}